import request from '@/utils/request'

/**
 * 业务人员-基本信息-详情(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function bizaccountBaseinfoGet(data) {
  return request({
    type: 'biz',
    url: 'bizaccount/baseinfo/get',
    method: 'post',
    data
  })
}

/**
 * 业务人员-基本信息-新增(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function bizaccountBaseinfoInsert(data) {
  return request({
    type: 'biz',
    url: 'bizaccount/baseinfo/insert',
    method: 'post',
    data
  })
}

/**
 * 业务人员-基本信息-更新(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function bizaccountBaseinfoUpdate(data) {
  return request({
    type: 'biz',
    url: 'bizaccount/baseinfo/update',
    method: 'post',
    data
  })
}

/**
 * 从业人员-删除(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function bizaccountDelete(data) {
  return request({
    type: 'biz',
    url: 'bizaccount/delete',
    method: 'post',
    data
  })
}

/**
 * 业务人员-用于手动将人员添加进商汤平台(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function bizaccountEmergency(data) {
  return request({
    type: 'biz',
    url: 'bizaccount/emergency',
    method: 'post',
    data
  })
}

/**
 * 业务人员-获取个人信息（学历、食堂、设备）(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function bizaccountGet(data) {
  return request({
    type: 'biz',
    url: 'bizaccount/get',
    method: 'post',
    data
  })
}

/**
 * 获取设备与人员关联信息()(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function bizaccountInnerDeviceUserJudge(data) {
  return request({
    type: 'biz',
    url: 'bizaccount/inner/device/user/judge',
    method: 'post',
    data
  })
}

/**
 * 业务人员-新增(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function bizaccountInsert(data) {
  return request({
    type: 'biz',
    url: 'bizaccount/insert',
    method: 'post',
    data
  })
}

/**
 * 获取组织所有从业人员
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function bizaccountOrgAllList(data) {
  return request({
    type: 'biz',
    url: 'bizaccount/org/all/list',
    method: 'post',
    data
  })
}

/**
 * 从业人员列表(分页)(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function bizaccountPageListGet(data) {
  return request({
    type: 'biz',
    url: 'bizaccount/page/list/get',
    method: 'post',
    data
  })
}

/**
 * 海康测温数据上传(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function bizaccountTemperatureUpload(data) {
  return request({
    type: 'biz',
    url: 'bizaccount/temperature/upload',
    method: 'post',
    data
  })
}

/**
 * undefined
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function bizaccountTemperatureUploadTest(data) {
  return request({
    type: 'biz',
    url: 'bizaccount/temperature/upload/test',
    method: 'post',
    data
  })
}

/**
 * 业务人员-更新(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function bizaccountUpdate(data) {
  return request({
    type: 'biz',
    url: 'bizaccount/update',
    method: 'post',
    data
  })
}

/**
 * token(临时性)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function token(data) {
  return request({
    type: 'biz',
    url: 'token',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/BizAccount.js